module.exports = __webpack_public_path__ + "img/hood height.5231d842.png";